import { type FC } from 'react';

import { MapLayersCenterContextProvider } from '@/microfrontends/map/shared/context/MapLayersCenterContext';
import { type MapLayersCenterContext } from '@/microfrontends/map/shared/types/MapLayersCenterContext';

import { MapActivePinUpdater } from '../MapActivePinUpdater';
import { MapClickHandler } from '../MapClickHandler';
import { MapHoverPinUpdater } from '../MapHoverPinUpdater';
import { MapPinsClickHandlers } from '../MapPinsClickHandlers';
import { MapPinsHoverHandlers } from '../MapPinsHoverHandlers/MapPinsHoverHandlers';
import { MapPinsUpdater } from '../MapPinsUpdater';

import { useAttachBallonManager } from './internal/hooks/useAttachBallonManager';
import { useAttachLayerToMap } from './internal/hooks/useAttachLayerToMap';
import { useInitBalloonManager } from './internal/hooks/useInitBalloonManager';
import { useInitHotspotsLayer } from './internal/hooks/useInitHotspotsLayer';
import { useInitPinsLayer } from './internal/hooks/useInitPinsLayer';

export const MapLayersCenter: FC = () => {
  const { pinsLayer, rbush } = useInitPinsLayer();
  const hotspotsLayer = useInitHotspotsLayer({ rbush });
  const balloonManager = useInitBalloonManager();

  useAttachLayerToMap(pinsLayer);
  useAttachLayerToMap(hotspotsLayer);
  useAttachBallonManager(balloonManager);

  const mapLayersCenterContext: MapLayersCenterContext = { balloonManager, hotspotsLayer, pinsLayer, rbush };

  return (
    <MapLayersCenterContextProvider value={mapLayersCenterContext}>
      <MapPinsUpdater />
      <MapActivePinUpdater />
      <MapPinsClickHandlers />
      <MapHoverPinUpdater />
      <MapPinsHoverHandlers />
      <MapClickHandler />
    </MapLayersCenterContextProvider>
  );
};
